import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as alert from '../alert/alertActions';
import { errorHandler } from '../../helpers/errorHandler';
import * as endpoints from '../../services/endpoints';
import * as types from './nftActionTypes';
import * as actions from './nftActions';

function* getNftsSaga() {
  try {
    const { data } = yield call(endpoints.getNfts);
    yield put(actions.getNftsActionData(data));
    yield put(actions.sortNftsAction());
  } catch (e) {
    errorHandler(e);
    yield put(actions.getNftsActionError(e));
  }
}

function* createNftSaga(action) {
  try {
    const { body } = action.payload;
    const { data } = yield call(endpoints.createNft, body, false);
    yield put(actions.createNftActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e);
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.createNftActionError(e));
  }
}

function* updateNftSaga(action) {
  try {
    const { nftID, body } = action.payload;
    const { data } = yield call(endpoints.updateNft, nftID, body);
    yield put(actions.updateNftActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e);
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.updateNftActionError(e));
  }
}

function* deleteNftSaga(action) {
  try {
    const { nftID } = action.payload;
    const { data } = yield call(endpoints.deleteNft, nftID);
    yield put(actions.deleteNftActionData(nftID));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e);
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.deleteNftActionError(e));
  }
}

function* watchGetNfts() {
  yield takeEvery(types.GET_NFTS_REQUEST, getNftsSaga);
}

function* watchCreateNft() {
  yield takeEvery(types.CREATE_NFT_REQUEST, createNftSaga);
}

function* watchUpdateNft() {
  yield takeEvery(types.UPDATE_NFT_REQUEST, updateNftSaga);
}

function* watchDeleteNft() {
  yield takeEvery(types.DELETE_NFT_REQUEST, deleteNftSaga);
}

export function* nftSaga() {
  yield all([watchGetNfts(), watchCreateNft(), watchUpdateNft(), watchDeleteNft()]);
}
